import { SafeUrl } from '@angular/platform-browser';

export class Orgimage {
    organizationId:string;
    date_added:Date;
    image?:string;
    orgimageurl?:string;
    type?:string;

}